module.exports = __webpack_public_path__ + "static/media/SliderImg3.7154ad90.png";